import { Site } from '@envato/foundation-types'
import isEmpty from 'lodash-es/isEmpty'

import { getConfigBySite } from '../../../config/sites'
import { ILocationParams } from '../../reducers/reactRouterLocation'
import isChildCategory from '../../utils/isChildCategory'

const getDefaultSortParam = (
  params: ILocationParams,
  currentSite: Site | 'defaults' = 'defaults'
) => {
  const { category } = params
  if (!isEmpty(params.term)) {
    return 'relevance'
  }

  const defaultSortBy = getConfigBySite(
    currentSite,
    'search_query.default_sort_by'
  )

  const defaultSortPerCategory = getConfigBySite(
    currentSite,
    'search_query.default_sort_by_per_category'
  )

  if (defaultSortPerCategory && category) {
    return Object.entries(defaultSortPerCategory)
      .filter(([key]) => category === key || isChildCategory(key, category))
      .sort(([key1], [key2]) => (key1 > key2 ? 1 : -1))
      .reduce((prev, [key, value]) => value, defaultSortBy)
  }

  return defaultSortBy
}

export default getDefaultSortParam
